import React, {useEffect, useState} from "react";
import "./Contact.css";
import {toast} from "react-toastify";
import ApiService from "../../network/ApiService";
import {useSelector} from "react-redux";
import QrCode from "../includes/QrCode";

function Contact(props) {
    console.log("checking from contact",props)
    const {contactEntry} = ApiService();
    const {organizationId} = useSelector((state) => state.organization);
    const contactList = props.contacts;
    // const phone = contactList.find((item) => item.contactType === "Phone");
    // const email = contactList.find((item) => item.contactType === "Email");
    const orgDetail = props.orgDetails;
    const [phone, setPhone] = useState(null);
    const [email, setEmail] = useState(null);
    const languageStatus = sessionStorage.getItem("language");

    const [inputData, setInputData] = useState({
        orgId: organizationId,
        contactName: "",
        contactEmail: "",
        contactSubject: "",
        contactDescription: "",
    });
    const handleChange = (e) => {
        //   return;
        const list = {...inputData};
        if (e.target) {
            const {name, value} = e.target;
            list[name] = value;
        } else {
            list["complainTypeId"] = e.value;
        }
        setInputData(list);
    };
    const submitContact = async () => {
        try {
            if (inputData.contactName === ''){
                toast.error("Name is Required");
                return;
            }
            else if (inputData.contactEmail === ''){
                toast.error("Email is Required");
                return;
            }else if(!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(inputData.contactEmail)){
                toast.error("Email should be Valid Email");
                return;
            }
            else if (inputData.contactSubject === ''){
                toast.error("Subject is Required");
                return;
            }
            else if (inputData.contactDescription === ''){
                toast.error("Message is Required");
                return;
            }
            const response = await contactEntry(inputData);
            setInputData({
                orgId: organizationId,
                contactName: "",
                contactEmail: "",
                contactSubject: "",
                contactDescription: "",
            });
            toast.success("Contact Information Submitted Successfully");
        } catch (error) {
            console.log(error)
            if (error.response){
                toast.error(error.response.data);
            }else{
                setInputData({
                    orgId: organizationId,
                    contactName: "",
                    contactEmail: "",
                    contactSubject: "",
                    contactDescription: "",
                });
                toast.success("Contact Information Submitted Successfully");
                // toast.error(error.message);
            }
        }
    };

    useEffect(() => {
        if (Object.keys(contactList).length > 0) {
            setPhone(contactList.find((item) => item.contactType === "Phone"));
            setEmail(contactList.find((item) => item.contactType === "Email"));
        }
    }, [contactList]);
    return (
        <>

            <div className="tm-page">
          <div className="uk-section uk-section-default section-contact">
            <div className="uk-container">
                <div uk-grid="true" className="uk-grid-medium">
                    <div className="uk-width-1-3@m uk-hidden">
                    <h2
                        className="uk-h2 uk-text-center uk-margin-auto uk-scrollspy-inview uk-margin-large"
                        uk-scrollspy-class=""
                    >
                        <span className="underline-secondary"> सम्पर्क </span>
                    </h2>
                        <div className="uk-flex uk-flex-column">
                            <label htmlFor="name">नाम</label>
                            <input
                                type="text"
                                name="contactName"
                                value={inputData.contactName}
                                onChange={(e) => handleChange(e)}
                                className="uk-input"
                                id="name"
                                placeholder="नाम"
                            />
                        </div>
                        <div className="uk-flex uk-flex-column uk-margin-top">
                            <label htmlFor="email">इमेल</label>
                            <input
                                type="text"
                                name="contactEmail"
                                value={inputData.contactEmail}
                                onChange={(e) => handleChange(e)}
                                className="uk-input"
                                id="email"
                                placeholder="इमेल"
                            />
                        </div>
                        <div className="uk-flex uk-flex-column uk-margin-top">
                            <label htmlFor="subject">विषय</label>
                            <input
                                type="text"
                                name="contactSubject"
                                value={inputData.contactSubject}
                                onChange={(e) => handleChange(e)}
                                className="uk-input"
                                id="subject"
                                placeholder="विषय"
                            />
                        </div>
                        <div className="uk-flex uk-flex-column uk-margin-top">
                            <label htmlFor="description">सन्देश</label>
                            <textarea
                                className="uk-textarea"
                                id="description"
                                name="contactDescription"
                                value={inputData.contactDescription}
                                onChange={(e) => handleChange(e)}
                                cols="30" rows="10"
                                placeholder="सन्देश"
                            />
                        </div>
                        <button
                            className="uk-button uk-button-primary uk-margin-small-left uk-align-right uk-margin-small-top"
                            onClick={() => submitContact()}
                        >सम्पर्क गर्नुहोस</button>
                    </div>
                    {/*<div className="uk-width-2-3@m">*/}
                    <div className="uk-width-1-1@m">
                        <div uk-grid="true">
                            {orgDetail && orgDetail.mapLink && orgDetail.mapLink.trim() !== "" ? (
                                <div className="uk-width-3-4@m">
                                <h3 className="uk-h3 uk-text-bold">{orgDetail ? (languageStatus === 'en' ? orgDetail.nameEnglish : orgDetail.nameNepali) : null}</h3>
                                {/*<h5 className="uk-text-bold">{orgDetail ? orgDetail.slogan : null}</h5>*/}
                                <hr />
                                <ul className="uk-list uk-scrollspy-inview " uk-scrollspy-class="">
                                    <li className="el-item">
                                        <div
                                            className="uk-grid-small uk-child-width-expand uk-flex-nowrap uk-flex-middle uk-grid"
                                            uk-grid="true"
                                        >
                                            <div className="uk-width-auto uk-first-column"><span
                                                className="el-image uk-icon"
                                                uk-icon="icon: location;"
                                            ></span></div>
                                            <div>
                                                <div className="el-content uk-panel">{orgDetail ? (languageStatus === 'en' ? orgDetail.addressEnglish : orgDetail.addressNepali) : null}</div>
                                            </div>
                                        </div>
                                    </li>
                                    <li className="el-item">
                                        <div
                                            className="uk-grid-small uk-child-width-expand uk-flex-nowrap uk-flex-middle uk-grid"
                                            uk-grid="true"
                                        >
                                            <div className="uk-width-auto uk-first-column"><span
                                                className="el-image uk-icon"
                                                uk-icon="icon: receiver;"
                                            ></span></div>
                                            <div>
                                                <div className="el-content uk-panel">{orgDetail ? (languageStatus === 'en' ? orgDetail.contactNumber : orgDetail.contactNumberNp) : null}</div>
                                            </div>
                                        </div>
                                    </li>
                            
                                    <li className="el-item">
                                        <div
                                            className="uk-grid-small uk-child-width-expand uk-flex-nowrap uk-flex-middle uk-grid"
                                            uk-grid="true"
                                        >
                                            <div className="uk-width-auto uk-first-column"><span
                                                className="el-image uk-icon"
                                                uk-icon="icon: mail;"
                                            ></span></div>
                                            <div>
                                                <div className="el-content uk-panel">{email ? email.contactAddress : null}</div>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            ) : <>
                                <div className="uk-width-3-4@m">
                                <h3 className="uk-h3 uk-text-bold">{orgDetail ? (languageStatus === 'en' ? orgDetail.nameEnglish : orgDetail.nameNepali) : null}</h3>
                               
                                    <hr />
                                <ul className="uk-list uk-scrollspy-inview " uk-scrollspy-class="">
                                    <li className="el-item">
                                        <div
                                            className="uk-grid-small uk-child-width-expand uk-flex-nowrap uk-flex-middle uk-grid"
                                            uk-grid="true"
                                        >
                                            <div className="uk-width-auto uk-first-column"><span
                                                className="el-image uk-icon"
                                                uk-icon="icon: location;"
                                            ></span></div>
                                            <div>
                                                <div className="el-content uk-panel">{orgDetail ? (languageStatus === 'en' ? orgDetail.addressEnglish : orgDetail.addressNepali) : null}</div>
                                            </div>
                                        </div>
                                    </li>
                                    <li className="el-item">
                                        <div
                                            className="uk-grid-small uk-child-width-expand uk-flex-nowrap uk-flex-middle uk-grid"
                                            uk-grid="true"
                                        >
                                            <div className="uk-width-auto uk-first-column"><span
                                                className="el-image uk-icon"
                                                uk-icon="icon: receiver;"
                                            ></span></div>
                                            <div>
                                                <div className="el-content uk-panel">{orgDetail ? (languageStatus === 'en' ? orgDetail.contactNumber : orgDetail.contactNumberNp) : null}</div>
                                            </div>
                                        </div>
                                    </li>
                          
                                    <li className="el-item">
                                        <div
                                            className="uk-grid-small uk-child-width-expand uk-flex-nowrap uk-flex-middle uk-grid"
                                            uk-grid="true"
                                        >
                                            <div className="uk-width-auto uk-first-column"><span
                                                className="el-image uk-icon"
                                                uk-icon="icon: mail;"
                                            ></span></div>
                                            <div>
                                                <div className="el-content uk-panel">{email ? email.contactAddress : null}</div>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            </>}
                            <div className="uk-width-1-4@m uk-text-center">
                            <div className="svg-square">
                                <QrCode value={orgDetail.hasOwnProperty('playstoreUrl') ? orgDetail.playstoreUrl : `https://play.google.com/store/apps/details?id=com.diyalo.bussewa`} />
                            </div>
                            </div>
                        </div>
                        <hr />
                        <div className="uk-margin-medium">
                        {orgDetail && orgDetail.mapLink ? (
                                <iframe
                                    src={orgDetail.mapLink}
                           
                                    width="100%"
                                    height="450"
                                    style={{border: 0}}
                                    allowFullScreen=""
                                    loading="lazy"
                                    referrerPolicy="no-referrer-when-downgrade"
                                    />
                        ) : null}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </div>
      </>
    );
}

export default Contact;
